import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportControleEstoqueUseCase } from "../../../presentation/useCases/read/get_report_controle_estoque_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";


export class GetReportControleEstoqueUseCase implements IGetReportControleEstoqueUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportControleEstoque(
    requiredMimeType: ReportMimeType | null,
    IdControleEstoque: number,
    IdUsuario: number
  ): Promise<ReportData> {
    const response = await this.repository.getReportControleEstoque(
      requiredMimeType, IdControleEstoque, IdUsuario
    );

    if (requiredMimeType !== "text/html") {
      const date = new Date().toISOString();
      const arquivoData = response.bytes;
      const arquivoNome =
        `ControleEstoque_${date}.${response.filenameExtension}`;

      await downloadBase64File(arquivoNome, arquivoData);
    }

    return response;
  }
}
